/**
 * English - `bookingServices`: the Services screen - what a shop takes
 * appointments for, how long each takes and what it costs. The storefront's
 * bookings section lists these; they belong to the store, not to a theme.
 */
const bookingServices: Record<string, string> = {
  title: 'Services',
  intro:
    "What customers can book with you. Active services appear in your storefront's bookings section and booking form, in this order. They are kept when you switch themes.",
  add: 'Add service',
  loading: 'Loading…',
  load_error: 'This list could not be loaded. Please refresh the page.',
  empty_title: 'No services yet',
  empty_description:
    'Add the first thing customers can book - a name and how long it takes is enough to start.',
  read_only: 'You can view this list but not change it.',
  visible: 'Shown',
  hidden: 'Hidden',
  on_consultation: 'Price on consultation',
  duration_minutes: '{minutes} min',
  duration_hours: '{hours} h',
  duration_hours_minutes: '{hours} h {minutes} min',
  'location.place': 'At your place',
  'location.online': 'Online',
  'location.address': "At the customer's address",
  move_up: 'Move up',
  move_down: 'Move down',
  edit: 'Edit',
  delete: 'Delete',
  delete_title: 'Delete service',
  delete_confirm:
    'Delete {name}? It disappears from your storefront and booking form. Past bookings keep its name. This cannot be undone.',
  saved: 'Saved.',
  deleted: 'Deleted.',
  generic_error: 'That did not save. Please try again.',

  'form.add_title': 'Add service',
  'form.edit_title': 'Edit service',
  'form.name': 'Name',
  'form.name_placeholder': 'Haircut and styling',
  'form.duration': 'Duration (minutes)',
  'form.duration_hint': 'How long one appointment takes. Booking times are spaced by this.',
  'form.price': 'Price',
  'form.price_hint': 'Leave blank to show "Price on consultation".',
  'form.description': 'Description',
  'form.image': 'Image',
  'form.image_hint': 'Optional. A photo of the service or the result.',
  'form.location': 'Where it happens',
  'form.location_note': 'Note for customers',
  'form.location_note_placeholder.place': 'Parking at the back',
  'form.location_note_placeholder.online': "We'll email a meeting link",
  'form.location_note_placeholder.address': 'We bring all equipment',
  'form.location_address_hint': 'The booking form will ask the customer for their address.',
  'form.is_active': 'Show on the storefront',
  'form.cancel': 'Cancel',
  'form.save': 'Save',
  'form.saving': 'Saving…',

  'hours.title': 'Appointment hours',
  'hours.intro':
    'When customers can book. These hours apply to every booking section on your storefront, unless a section is set to use its own hours in the theme customizer.',
  'hours.closed': 'Closed',
  'hours.closed_label': 'Closed on {day}',
  'hours.opens': 'Opens',
  'hours.closes': 'Closes',
  'hours.opens_label': '{day} opens',
  'hours.closes_label': '{day} closes',
  'hours.save': 'Save hours',
  'hours.saved': 'Appointment hours saved.',
  'hours.load_error': 'Your appointment hours could not be loaded. Please refresh the page.',

  'errors.required': 'This field is required.',
  'errors.duration': 'Enter whole minutes between {min} and {max}.',
  'errors.price': 'Enter a price of 0 or more, or leave it blank.',
  'errors.hours_order': 'On {day}, closing time must be after opening time.',
  'form.payment_mode': 'Payment',
  'form.payment_default': 'Store default',
  'form.deposit_type': 'Deposit',
  'form.deposit_default': 'Store deposit',
  'form.payment_hint': 'Used once online booking payments are switched on in Bookings. A service with no price is paid at the venue.',
};

export default bookingServices;
